package br.com.vvrefeicoes.portal.feature.users

import br.com.vvrefeicoes.portal.domain.model.UserImportRow

internal data class UserImportPreviewData(
    val rows: List<UserImportRow>,
    val totalRows: Int,
    val missingEmail: Int,
    val duplicateEmails: Int,
)

internal fun parseUserImportRows(grid: List<List<String>>): UserImportPreviewData {
    if (grid.isEmpty()) {
        throw IllegalArgumentException("A planilha está vazia.")
    }
    val header = grid.first().map(::normalizeHeader)
    val nameIndex = header.indexOf("nome do funcionario").takeIf { it >= 0 } ?: header.indexOf("funcionario")
    val emailIndex = header.indexOf("email")
    val sectorIndex = header.indexOf("departamento")
    val cargoIndex = header.indexOf("funcao")
    val phoneIndex = header.indexOf("telefone")
    if (nameIndex < 0 || emailIndex < 0) {
        throw IllegalArgumentException("A planilha precisa ter as colunas Nome do Funcionário e Email.")
    }

    val rows = mutableListOf<UserImportRow>()
    val seenEmails = mutableSetOf<String>()
    var missingEmail = 0
    var duplicateEmails = 0
    grid.drop(1).forEach { row ->
        val name = row.getOrNull(nameIndex)?.trim().orEmpty()
        val email = row.getOrNull(emailIndex)?.trim().orEmpty()
        val hasContent = row.any { it.isNotBlank() }
        if (!hasContent) return@forEach
        if (email.isBlank()) {
            missingEmail++
        } else if (!seenEmails.add(email.lowercase())) {
            duplicateEmails++
        }
        rows +=
            UserImportRow(
                name = name,
                email = email,
                sector = row.getOrNull(sectorIndex)?.trim().orEmpty(),
                cargo = row.getOrNull(cargoIndex)?.trim().orEmpty(),
                phone = row.getOrNull(phoneIndex)?.trim().orEmpty(),
            )
    }
    if (rows.isEmpty()) {
        throw IllegalArgumentException("Nenhuma linha com e-mail foi encontrada.")
    }
    return UserImportPreviewData(
        rows = rows,
        totalRows = grid.size - 1,
        missingEmail = missingEmail,
        duplicateEmails = duplicateEmails,
    )
}

private fun normalizeHeader(value: String): String =
    value
        .trim()
        .lowercase()
        .replace('á', 'a')
        .replace('à', 'a')
        .replace('â', 'a')
        .replace('ã', 'a')
        .replace('é', 'e')
        .replace('ê', 'e')
        .replace('í', 'i')
        .replace('ó', 'o')
        .replace('ô', 'o')
        .replace('õ', 'o')
        .replace('ú', 'u')
        .replace('ç', 'c')
        .replace(Regex("\\s+"), " ")
